"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Leaf, Lightbulb, Shield } from "lucide-react";
export default function OurFoundation() {
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: iconsRef,
    isVisible: iconsVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="our-foundation" className="bg-background py-16 md:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div ref={containerRef} className={`text-center mb-12 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${containerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-foreground mb-6">Our Foundation</h2>
          <p className="text-muted-foreground text-lg leading-relaxed max-w-3xl mx-auto">
            West Indian Digital is built on the principle of repurposing stranded and vented methane from oil and gas production to power Bitcoin mining operations. Our infrastructure combines energy efficiency with carbon impact reduction, while our digital asset strategies operate under disciplined risk management and institutional governance standards.
          </p>
        </div>

        <div ref={iconsRef} className={`grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-12 max-w-2xl mx-auto transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${iconsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <div data-index={0} className="flex flex-col items-center text-center group">
            <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:bg-primary/20 group-hover:scale-110">
              <Leaf className="w-8 h-8 text-accent" />
            </div>
            <h3 className="text-base font-semibold text-foreground">Environment</h3>
          </div>

          <div data-index={1} className="flex flex-col items-center text-center group">
            <div className="w-16 h-16 rounded-full bg-secondary/10 flex items-center justify-center mb-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:bg-secondary/20 group-hover:scale-110">
              <Lightbulb className="w-8 h-8 text-secondary" />
            </div>
            <h3 className="text-base font-semibold text-foreground">Innovation</h3>
          </div>

          <div data-index={2} className="flex flex-col items-center text-center group">
            <div className="w-16 h-16 rounded-full bg-accent/10 flex items-center justify-center mb-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:bg-accent/20 group-hover:scale-110">
              <Shield className="w-8 h-8 text-accent" />
            </div>
            <h3 className="text-base font-semibold text-foreground">Security</h3>
          </div>
        </div>
      </div>
    </section>;
}